import { createSlice } from '@reduxjs/toolkit';

const apiSlice = createSlice({
    name: 'apiSlice',
    initialState: {},
    reducers: {},
});

export default apiSlice;
